import React from 'react';

import classes from './HeaderRow.module.scss';
import { Row } from '../../../../../pages/customers-dashboard/components/Row/Row';

const HeaderRow = () => {
  return (
    <Row className={classes.header}>
      <div>Name of Supplement</div>
      <div>Inventory Balance</div>
      <div>Amount of Order</div>
      <div>Date of Order</div>
      <div>Status</div>
    </Row>
  );
};

export { HeaderRow };
